<div
    [ngClass]="{
        'bg-black-130 dark:bg-gray-700': (impersonate$ | async) === true,
        'bg-white dark:bg-gray-700': (impersonate$ | async) === false,
    }"
    class="flex md:items-stretch items-center flex-row border-b border-solid border-black-200">
    <div class="grow m-3">
        @if (logoUrl$ | async; as logoUrl) {
            <a class="navbar-item" routerLink="./">
                <img [src]="logoUrl" alt="Partner Logo" class="max-h-12" />
            </a>
        } @else {
            <a class="navbar-item" routerLink="./">
                <img alt="Partner Logo" height="28" src="/assets/img/navlogo.svg" width="112" />
            </a>
        }
    </div>
    <div [innerHTML]="'HEADER.HINT.DIMENSION' | translate" class="text-red text-xs text-right m-3 mr-4 mobileHint:hidden"></div>
    <div class="hidden md:flex items-stretch">
        <je-download-link-area></je-download-link-area>
        @if (role.id === RoleName.OrderRecording) {
            <button
                (click)="onDownloadAgb()"
                class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
                type="button">
                <div class="mr-0.5 hidden xl:block">
                    {{ 'AGB' | translate }}
                </div>
                <je-fa-icon [name]="'download'"></je-fa-icon>
            </button>
        }
        <button
            (click)="onErrorSubmit()"
            class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
            type="button">
            <div class="mr-0.5 hidden xl:block">
                {{ 'LOGININFO.REPORT_ERROR' | translate }}
            </div>
            <je-fa-icon [name]="'messages-question'"></je-fa-icon>
        </button>

        @if (roles.length > 1) {
            <button
                type="button"
                class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
                (click)="onRoleChange()">
                <div class="mr-0.5 hidden xl:block">{{ role.description }}</div>
                <je-fa-icon [name]="'people-roof'"></je-fa-icon>
            </button>
        }

        @if (showCustomerSelection) {
            <button
                type="button"
                class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
                (click)="onCustomerChange()">
                <div class="mr-0.5 hidden xl:block">
                    {{ (customer$ | async).name }}
                </div>
                <je-fa-icon [name]="'industry-windows'"></je-fa-icon>
            </button>
        }

        @if (showPartnerSelection) {
            <button
                type="button"
                class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
                (click)="onPartnerChange()">
                <div class="mr-0.5 hidden xl:block">
                    {{ partnerName$ | async }}
                </div>
                <je-fa-icon [name]="'buildings'"></je-fa-icon>
            </button>
        }

        @if ((impersonate$ | async) === true) {
            <button
                type="button"
                class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
                (click)="onProfileClicked()">
                <div class="flex flex-col items-center">
                    <small class="dark:text-gray-300">{{ 'PROFILE.TOP_NAV_TEXT_DEPUTY' | translate }}</small>
                    <div class="mr-0.5">{{ username$ | async }}</div>
                </div>
                <je-fa-icon [name]="'user'"></je-fa-icon>
            </button>
        } @else {
            <button
                type="button"
                class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
                (click)="onProfileClicked()">
                <div class="mr-0.5 hidden xl:block">
                    {{ username$ | async }}
                </div>
                <je-fa-icon [name]="'user'"></je-fa-icon>
            </button>
        }

        <button
            (click)="onLogout()"
            class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
            type="button">
            <div class="mr-0.5 hidden xl:block">
                {{ 'LOGININFO.LOGOUT' | translate }}
            </div>
            <je-fa-icon [name]="'right-from-bracket'"></je-fa-icon>
        </button>
        <button
            (click)="toggleDisplayMode()"
            class="flex flex-row items-center p-4 xl:p-2 border-0 border-r border-solid border-r-black-200 hover:bg-gray-500 dark:hover:bg-gray-700"
            type="button">
            @if (this.displayMode === DisplayMode.lightMode) {
                <je-fa-icon [name]="'moon-stars'"></je-fa-icon>
            }
            @if (this.displayMode === DisplayMode.darkMode) {
                <je-fa-icon [name]="'sun-bright'"></je-fa-icon>
            }
        </button>
    </div>
    <div class="md:hidden m-3">
        <je-fa-icon (click)="toggleMobileMenu()" [name]="'bars'"></je-fa-icon>
    </div>
    @if (mobileMenuOpen) {
        <div class="flex flex-col absolute top-16 left-0 right-0 bg-gray-300 dark:bg-gray-800 z-200 shadow">
            <je-download-link-area [isMobileMenuOpen]="mobileMenuOpen"></je-download-link-area>

            <button type="button" (click)="onErrorSubmit()" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200">
                <je-fa-icon [name]="'messages-question'"></je-fa-icon>
                <div class="ml-0.5">
                    {{ 'LOGININFO.REPORT_ERROR' | translate }}
                </div>
            </button>

            @if (roles.length > 1) {
                <button type="button" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200" (click)="onRoleChange()">
                    <je-fa-icon [name]="'people-roof'"></je-fa-icon>
                    <div class="ml-0.5">{{ role.description }}</div>
                </button>
            }

            @if (showCustomerSelection) {
                <button type="button" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200" (click)="onCustomerChange()">
                    <je-fa-icon [name]="'industry-windows'"></je-fa-icon>
                    <div class="ml-0.5">{{ (customer$ | async).name }}</div>
                </button>
            }

            @if (showPartnerSelection) {
                <button type="button" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200" (click)="onPartnerChange()">
                    <je-fa-icon [name]="'buildings'"></je-fa-icon>
                    <div class="ml-0.5">{{ partnerName$ | async }}</div>
                </button>
            }

            @if ((impersonate$ | async) === true) {
                <button type="button" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200" (click)="onProfileClicked()">
                    <je-fa-icon [name]="'user'"></je-fa-icon>
                    <div class="flex items-center ml-0.5">
                        <small>{{ 'PROFILE.TOP_NAV_TEXT_DEPUTY' | translate }}</small>
                        <div class="ml-0.5">{{ username$ | async }}</div>
                    </div>
                </button>
            } @else {
                <button type="button" class="flex flex-row items-center py-3 px-2 border-0 border-b border-solid border-black-200" (click)="onProfileClicked()">
                    <je-fa-icon [name]="'user'"></je-fa-icon>
                    <div class="ml-0.5">{{ username$ | async }}</div>
                </button>
            }

            <button (click)="onLogout()" type="button" class="flex flex-row items-center py-3 px-2">
                <je-fa-icon [name]="'right-from-bracket'"></je-fa-icon>
                <div class="ml-0.5">
                    {{ 'LOGININFO.LOGOUT' | translate }}
                </div>
            </button>
        </div>
    }
</div>
